<script>
  import Origin from 'components/eHorizon/Destination/Origin'
  import Item from 'components/eHorizon/Destination/DestinItem'

  export default {

    components: {
      item: Item
    },
    extends: Origin,

    methods: {
      maybeSelect () {
        if (this.options.length === 2) {
          const firstOption = this.options[1]
          if (this.value !== firstOption.aptWithCode) {
            this.updateValue(firstOption)
            this.blurInput()
          }
        }
      }
    }
  }
</script>
